var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-card",
    {
      staticClass: "cardClassDetailForm no-margin",
      attrs: { title: "작업위험성평가" },
    },
    [
      _c("template", { slot: "card-detail" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "c-table",
              {
                key: _vm.tableKey,
                ref: "usertable",
                attrs: {
                  isTitle: "",
                  title: "JSA 참가자",
                  columns: _vm.grid2.columns,
                  gridHeightAuto: true,
                  data: _vm.workPermit.assessUsers,
                  filtering: false,
                  columnSetting: false,
                  usePaging: false,
                  editable: _vm.editable && _vm.isWriting,
                  selection: "multiple",
                  rowKey: "sopWorkAssessUserId",
                },
                on: { changeDataLength: _vm.changeDataLength },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가(작업업체 근무자)",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.addVendorUser },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가(현업)",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.addUser },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "제외",
                                icon: "remove",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.removeUser },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "c-table",
              {
                ref: "table",
                staticClass: "q-mt-sm",
                attrs: {
                  isTitle: "",
                  title: "안전조치사항",
                  columns: _vm.grid.columns,
                  gridHeightAuto: true,
                  data: _vm.workPermit.assessments,
                  filtering: false,
                  columnSetting: false,
                  usePaging: false,
                  editable: _vm.editable && _vm.isWriting,
                  selection: "multiple",
                  rowKey: "sopWorkSopAssessmentId",
                },
                on: { "table-data-change": _vm.tableDataChange },
              },
              [
                _c(
                  "template",
                  { slot: "table-button" },
                  [
                    _c(
                      "q-btn-group",
                      { attrs: { outline: "" } },
                      [
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "추가",
                                icon: "add",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.add },
                            })
                          : _vm._e(),
                        _vm.editable && _vm.isWriting
                          ? _c("c-btn", {
                              attrs: {
                                label: "제외",
                                icon: "remove",
                                showLoading: false,
                              },
                              on: { btnClicked: _vm.remove },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }